module.exports = __webpack_public_path__ + "static/BeVapeFree.org_Privacy-Policy_2020-b525f4926aaae340603389c686d95f7c.pdf";